import { useEffect, useState } from "react";

/**
 * Per-device rotation offset for a signed-out visitor: returns the offset
 * stored under `storageKey` and advances it by one after mount, so each visit
 * opens on a different lead card. The read happens in the initializer and the
 * increment in an effect (never during render), so it's SSR- and
 * StrictMode-safe — a double-invoked effect writes the same value twice, not
 * two increments.
 *
 * @param {string} storageKey
 * @returns {number}
 */
export function useRotationOffset(storageKey) {
  const [offset] = useState(() => {
    try {
      return Number(window.localStorage.getItem(storageKey) || "0") || 0;
    } catch {
      return 0;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(storageKey, String(offset + 1));
    } catch {
      // localStorage unavailable (private mode / SSR) — the offset stays put.
    }
  }, [storageKey, offset]);

  return offset;
}
